<template>
	<div class="job--tiles__wrapper">
		<div class="grid-items">
			<div class="tile__position">
				<router-link to="/open-application">
					<img
						src="/static/img/job_openings/view_more_1.jpg"
						width="100%"
						height="100%"
						class="position_img"
					/>
					<div class="gradient-img gradient-img-bg__positions"></div>
					<div class="overlay">
						<div class="heading-wrapper">
							<h2 class="heading--tile">OPEN APPLICATION</h2>
							<div class="arrow--button__text">
								Apply Now<i
									class="icons8-featured-right-arrow-01"
								></i>
							</div>
						</div>
					</div>
				</router-link>
			</div>
		</div>

		<div class="grid-items">
			<div class="tile__application">
				<router-link to="/internships">
					<img
						src="/static/img/job_openings/view_more_internships_1.jpg"
						width="100%"
						height="100%"
						class="position_img"
					/>
					<div
						class=" gradient-img gradient-img-bg__application"
					></div>
					<div class="overlay">
						<div class="heading-wrapper">
							<h2 class="heading--tile">Internships</h2>
							<div class="arrow--button__text">
								Apply Now<i
									class="icons8-featured-right-arrow-01"
								></i>
							</div>
						</div>
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "job-tiles"
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../assets/scss/main";

.job--tiles__wrapper {
	padding-bottom: 80px;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	justify-content: center;
	align-items: flex-start;
}

.grid-items {
	//  flex: 1 !important;
	@media (max-width: 768px) {
		padding-right: 0 !important;
		padding-left: 0 !important;
		flex-basis: 100%;
		//flex: none;
	}
	@media (min-width: 768px) {
		padding: 20px;
		flex-basis: 50%;
	}
}

.tile__position {
	.gradient-img {
		opacity: 0.9;
		transition: opacity 0.68s ease-out;
	}
	background-image: url("/static/img/job_openings/view_more_1.jpg");
	position: relative;
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center;
	transition: background-size 0.68s ease-out;
	margin-bottom: 2em;
	&:hover {
		background-size: 110% 110%;
		.gradient-img {
			opacity: 1;
		}
	}
}

.tile__application {
	background-image: url("/static/img/job_openings/view_more_internships_1.jpg");
	position: relative;
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center;
	transition: background-size 0.68s ease-out;
	.gradient-img {
		opacity: 0.75;
		transition: opacity 0.68s ease-out;
	}
	&:hover {
		background-size: 110% 110%;
		.gradient-img {
			opacity: 0.9;
		}
	}
}

.gradient-img {
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0;
	opacity: 0.9;
}

.gradient-img-bg__positions {
	background-image: linear-gradient(
		to top,
		rgba(251, 176, 59, 0.9) 0%,
		rgba(244, 77, 82, 0.9) 100%
	);
}

.gradient-img-bg__application {
	background-image: linear-gradient(180deg, #00ba88 0%, #ffdf59 100%);
}

.gradient-img-bg__subs {
	background-image: linear-gradient(
		to top,
		rgba(251, 176, 59, 0.9) 0%,
		rgba(81, 35, 221, 0.9) 100%
	);
}

.position_img {
	opacity: 0;
}

.overlay {
	height: 100%;
	width: 100%;
	top: 0;
	position: absolute;
	color: white;
}

.heading--tile {
	text-transform: uppercase;
	position: relative;
	width: 100%;
}

.heading-wrapper {
	width: 100%;
	display: flex;
	flex-flow: row;
	flex-direction: column;
	flex-wrap: wrap;
	align-items: flex-end;
	justify-content: flex-end;
	height: 100%;
	padding: 30px;
	@media (min-width: $tablet) {
		padding: 65px;
	}
	&:hover {
		.arrow--button__text {
			color: #fff;
		}
	}
}

.arrow--button__text {
	transition: all 0.3s ease-out;
	padding-top: 30px;
	height: 20px;
	@media (max-width: $tablet) {
		height: 65px;
	}
	width: 100%;
}

.lowered_text {
	top: 32%;
}
</style>



// WEBPACK FOOTER //
// src/components/JobTiles.vue